"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInRequest = void 0;
var SignInRequest = /** @class */ (function () {
    function SignInRequest() {
    }
    return SignInRequest;
}());
exports.SignInRequest = SignInRequest;
//# sourceMappingURL=signIn.request.js.map